export let UsageTrackingScreen;
(function (UsageTrackingScreen) {
  UsageTrackingScreen["DETAIL"] = "document detail";
  UsageTrackingScreen["INDEX"] = "index";
})(UsageTrackingScreen || (UsageTrackingScreen = {}));